import { Inject, Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { API_URL_TOKEN, PROD_TOKEN } from '../tokens/tokens';

@Injectable({
  providedIn: 'root'
})
export class ApiAuthInterceptor implements HttpInterceptor {

  constructor(
    private auth: AuthService,
    @Inject(PROD_TOKEN) private prod: boolean,
    @Inject(API_URL_TOKEN) private apiUrl: string
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.url.includes(this.apiUrl + '/') || request.url.includes('https://api.h2delta.com/') || request.url.includes('/graphql') || (request.url.includes('https://us-central1-linescale-dev.cloudfunctions.net/') && request.url.includes('/api/')) || (!this.prod && request.url.includes('/api/')) || request.url.includes('/funcs') || request.url.includes('/capi/')) {
      const duplicate = request.clone({
        headers: new HttpHeaders({
          'Authorization': 'Bearer ' + this.auth.token
        })
      });

      return next.handle(duplicate);
    }

    return next.handle(request);
  }
}
